/**
 * ChipMarkerIcon — 캘린더 chip 왼쪽 카테고리 마커 아이콘.
 *
 * 모든 일정 카테고리에 표시 (2026-06-03):
 *  - lock      (개인 일정)
 *  - hash      (내 채널 일정)
 *  - shared    (공유받은 일정 / 공유받은 채널 일정)
 *  - mail      (초대받은 일정)
 *  - building  (전사 일정)
 *  - calendar  (공휴일)
 *  - list-todo (Task 마감일)
 */
import React from 'react';
import { Lock, Hash, Mail, Building2, Calendar, Share2, ListTodo } from 'lucide-react';
import { ChipMarkerKey } from '../../../models/CalendarEvent';
import { cn } from '../../../lib/utils';

interface Props {
  marker?: ChipMarkerKey;
  className?: string;
}

const ICON_MAP: Record<NonNullable<ChipMarkerKey>, React.ElementType> = {
  lock: Lock,
  hash: Hash,
  mail: Mail,
  building: Building2,
  calendar: Calendar,
  shared: Share2,
  'list-todo': ListTodo,
};

const ChipMarkerIcon: React.FC<Props> = ({ marker, className }) => {
  if (!marker) return null;
  const Icon = ICON_MAP[marker];
  if (!Icon) return null;
  return <Icon className={cn('shrink-0', className)} />;
};

export default ChipMarkerIcon;
